export default "__VITE_ASSET__2bdf3029__"